import { render, staticRenderFns } from "./ExerciseView.vue?vue&type=template&id=4a0eb88b&"
import script from "./ExerciseView.vue?vue&type=script&lang=ts&"
export * from "./ExerciseView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports